module.exports = __webpack_public_path__ + "img/card-rempro-invoices-report.f7e6a764.svg";